import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import bowser from 'yola-bowser';
import Heading from '../heading';
import SkeletonFill from '../skeletons/skeleton-fill';
import TextSkeleton from '../skeletons/text-skeleton';
import Actions from './components/actions';
import { ACTIONS_TYPES, captionsType } from './types';

const TemplatePreviewContainer = ({
  title,
  onPreviewClick,
  onStartEditingClick,
  previewUrl,
  captions,
  isLoading,
  layout3Cols = false,
}) => {
  const isTouchDevice = bowser.mobile || bowser.tablet;
  const [isImageLoading, setIsImageLoading] = useState(true);

  const handleImageLoad = () => setIsImageLoading(false);

  const classes = classNames('ws-ui-template-preview-container', {
    'ws-ui-template-preview-container--loading': isImageLoading,
    'ws-ui-template-preview-container--touch-device': isTouchDevice,
    'ws-ui-template-preview-container--3-col': layout3Cols,
  });

  return (
    <div className={classes}>
      <div className="ws-ui-template-preview-container__media">
        <div className="ws-ui-template-preview-container__media-inner">
          {(isLoading || isImageLoading) && <SkeletonFill />}
          <img
            className="ws-ui-template-preview-container__image"
            src={previewUrl}
            onLoad={handleImageLoad}
            alt=""
          />
          {!isTouchDevice && !isImageLoading && !isLoading && (
            <div className="ws-ui-template-preview-container__media-overlay">
              <Actions
                captions={captions}
                onPreviewClick={onPreviewClick}
                onStartEditingClick={onStartEditingClick}
                type={ACTIONS_TYPES.floating}
              />
            </div>
          )}
        </div>
      </div>
      <div className="ws-ui-template-preview-container__content">
        <Actions
          captions={captions}
          isLoading={isLoading || isImageLoading}
          onPreviewClick={onPreviewClick}
          onStartEditingClick={onStartEditingClick}
        />
        <div className="ws-ui-template-preview-container__title">
          {isLoading || isImageLoading ? (
            <TextSkeleton />
          ) : (
            <Heading singleLine type="heading-5">
              {title}
            </Heading>
          )}
        </div>
      </div>
    </div>
  );
};

TemplatePreviewContainer.propTypes = {
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  previewUrl: PropTypes.string.isRequired,
  onPreviewClick: PropTypes.func.isRequired,
  onStartEditingClick: PropTypes.func.isRequired,
  captions: PropTypes.shape(captionsType).isRequired,
  layout3Cols: PropTypes.bool,
};

export default TemplatePreviewContainer;
